import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'module-tsl-ui-elements';

var ElementsHeader = function ElementsHeader(_ref) {
  var activeSubject = _ref.activeSubject,
      cxContentLocation = _ref.cxContentLocation,
      title = _ref.title,
      mz = _ref.mz;
  return /*#__PURE__*/React.createElement("article", {
    className: "elements"
  }, /*#__PURE__*/React.createElement("h1", {
    "data-cx-content-item": "{{{content:".concat(cxContentLocation, ":").concat(cxContentLocation, "_title}}}"),
    className: "elements__title"
  }, title), activeSubject === 'elements-home' ? /*#__PURE__*/React.createElement("p", {
    "data-cx-content-item": "{{{content:".concat(cxContentLocation, ":").concat(cxContentLocation, "_description}}}"),
    className: "mb-2"
  }, "Everything you'll ever need to teach for key stages 1 & 2.") : /*#__PURE__*/React.createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    "data-cx-content-item": "{{{content:".concat(cxContentLocation, ":").concat(cxContentLocation, "_description}}}"),
    className: "elements__description ".concat(cxContentLocation),
    id: "elements-header-description-container"
  }, /*#__PURE__*/React.createElement("p", null, "A vast library of easy-to-use interactive and printable teaching resources perfect for KS1 and KS2. Everything you need to bring the primary curriculum to life \u2013 all in one simple subscription."), /*#__PURE__*/React.createElement("p", null, "Tes elements contains a comprehensive selection of hundreds of engaging, interactive tools, videos and games to help raise student engagement and attainment across KS1 and KS2. These cover multiple topics across literacy, numeracy and phonics schemes with additional modules for SATs preparation tests, personal, social and health education (PSHE) and British History."), /*#__PURE__*/React.createElement("p", null, "As well as the interactive activities for use with students, Tes element resources also contain attachments to help teachers to tailor learning with differentiated materials and supporting worksheets for classwork, homework and practice tests.")), /*#__PURE__*/React.createElement("a", {
    id: "elements-description-read-more-button",
    className: "elements__description--readMore tes-btn ".concat(cxContentLocation)
  }, "Read more"), /*#__PURE__*/React.createElement("script", {
    dangerouslySetInnerHTML: {
      __html: "document.getElementById('elements-description-read-more-button').onclick = function () {\n                document.getElementById('elements-header-description-container').classList.add('read-more');\n                this.classList.add('hidden');\n              };"
    }
  })), /*#__PURE__*/React.createElement("div", {
    id: "elements-subscribe-btn",
    className: "margin-bottom-lg"
  }, /*#__PURE__*/React.createElement(Button, {
    "data-mz": !!mz,
    "data-module": mz,
    "data-id": "elements-banner-subscribe-btn",
    href: "/elements",
    size: "lg",
    theme: "secondary",
    className: "tds-btn--elements"
  }, "Subscribe now")));
};

ElementsHeader.displayName = "ElementsHeader";
ElementsHeader.propTypes = {
  activeSubject: PropTypes.string,
  cxContentLocation: PropTypes.string,
  title: PropTypes.string.isRequired,
  mz: PropTypes.string
};
var defaultNavigation = [{
  title: 'Spag'
}, {
  title: 'Phonics'
}, {
  title: 'Number'
}, {
  title: 'Comprehension'
}, {
  title: 'Maths SATs Skills'
}, {
  title: 'Traditional Tales'
}, {
  title: 'Wolf Maths'
}, {
  title: 'Fractions'
}, {
  title: 'PSHE'
}, {
  title: 'British History'
}, {
  title: 'iBoard'
}];
ElementsHeader.defaultProps = {
  activeSubject: 'elements-home',
  cxContentLocation: 'elements_home',
  title: 'Home',
  elementsSubjects: defaultNavigation
};
export default ElementsHeader;